function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#6ec7ef;opacity:0.2;mix-blend-mode:overlay;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "BACKGROUND"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "372.95 516.78 489.87 449.26 551.78 485.07 434.86 552.59 372.95 516.78"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "388.29 455.98 503.43 389.49 564.39 424.76 449.25 491.24 388.29 455.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "352.88 211.31 468.01 144.83 528.98 180.1 413.84 246.58 352.88 211.31"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "434.06 66.48 549.2 0 610.16 35.27 495.03 101.75 434.06 66.48"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "462.37 315.98 577.5 249.5 638.47 284.76 523.33 351.25 462.37 315.98"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "126.08 488.35 241.22 421.87 302.18 457.13 187.05 523.62 126.08 488.35"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "13.39 510.92 128.53 444.43 189.49 479.7 74.36 546.18 13.39 510.92"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "168.51 185.59 283.65 119.11 344.61 154.38 229.48 220.86 168.51 185.59"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "0 168.42 145.45 84.43 222.47 128.99 77.02 212.97 0 168.42"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-2",
  points: "97.81 83.99 243.25 0 320.27 44.55 174.82 128.54 97.81 83.99"
}))));

var SvgLayer2 = function SvgLayer2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 638.47 552.59",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLayer2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Layer2.89731a93.svg";
export { ForwardRef as ReactComponent };